module.exports = __webpack_public_path__ + "img/python-logo.81006556.svg";